import axiosClient from "../apiClient.js";
import axios from "axios";

const baseEndpoint = "/ahaval";

export const ahavalObject = {
  userName: "",
  id: 0,
  fileName: "",
  fromPeriod: "",
  fromPeriodId: 0,
  toPeriod: "",
  toPeriodId: 0,
  period: "",
  image: "",
  file: null,
};

export const getPreview = () => {
  return axiosClient.get(`${baseEndpoint}/getpreview`);
};

export const save = (data) => {
  return axios.post(`/api${baseEndpoint}/save`, data);
};

export const update = (data) => {
  return axios.post(`/api${baseEndpoint}/update`, data);
};

export const download = (path) => {
  return axios.get(`/api${baseEndpoint}/download?path=${path}`, {
    responseType: "blob",
  });
};

export const publish = (data) => {
  return axios.post(`/api${baseEndpoint}/publish`, data);
};

export const deletePreview = (data) => {
  return axios.post(`/api${baseEndpoint}/deletepreview`, data);
};

export const deleteLive = (data) => {
  return axios.post(`/api${baseEndpoint}/deletelive`, data);
};

export const getLive = () => {
  return axiosClient.get(`${baseEndpoint}/getlive`);
};

export const getLiveById = (id) => {
  return axiosClient.get(`${baseEndpoint}/getlivebyid?id=${id}`);
};

export const getPreviewById = (id) => {
  return axiosClient.get(`${baseEndpoint}/getPreviewById?id=${id}`);
};

export const getLiveByPeriod = (period) => {
  return axiosClient.get(`${baseEndpoint}/getlivebyperiod?period=${period}`);
};

export const getPreviewByPeriod = (period) => {
  return axiosClient.get(`${baseEndpoint}/getpreviewbyperiod?period=${period}`);
};

export const getLivePeriod = () => {
  return axiosClient.get(`${baseEndpoint}/getliveperiod`);
};

export const getPreviewPeriod = () => {
  return axiosClient.get(`${baseEndpoint}/getpreviewperiod`);
};
